import { Button } from '@/lib';
import { useTranslation } from 'react-i18next';

export const VIEW_MODES = {
  CARD: 'card',
  TABLE: 'table',
} as const;

export type ViewMode = 'card' | 'table';

export interface ViewToggle {
  viewMode: ViewMode;
  onViewModeChange: (mode: ViewMode) => void;
}

const viewModes: ViewMode[] = [VIEW_MODES.CARD, VIEW_MODES.TABLE];

export const ViewToggle = ({ viewMode, onViewModeChange }: ViewToggle) => {
  const { t } = useTranslation();

  return (
    <div className='flex items-center gap-2'>
      {viewModes.map((mode) => (
        <Button key={mode} intent={viewMode === mode ? 'primary' : 'secondary'} size='sm' onClick={() => onViewModeChange(mode as ViewMode)}>
          {t(`COMMON:${mode}View`)}
        </Button>
      ))}
    </div>
  );
};
